module.exports = __webpack_public_path__ + "img/home-clothing6.6ff39fa6.png";